<template>
  <div class="login-entry ">
    <block-head-line title="快捷入口" :hid-more-btn="true" />
    <ul class="f-b-c mt-20">
      <li>
        <a :href="dljgEntryLink" title="国有资产交易" target="_blank">
          <img src="@/assets/images/home/login-entry-1.jpg" alt="国有资产交易">
          <span class="span">国有资产交易</span>
          <span class="border" />
        </a>
      </li>
      <li>
        <a :href="pwEntryLink" title="阳光招标采购" target="_blank">
          <img src="@/assets/images/home/login-entry-4.jpg" alt="阳光招标采购">
          <span class="span">阳光招标采购</span>
          <span class="border" />
        </a>
      </li>
      <li>
        <a :href="gysEntryLink" title="农村产权交易" target="_blank">
          <img src="@/assets/images/home/login-entry-3.jpg" alt="农村产权交易">
          <span class="span">农村产权交易</span>
          <span class="border" />
        </a>
      </li>
      <li>
        <a :href="cgfEntryLink" title="自然资源交易" target="_blank">
          <img src="@/assets/images/home/login-entry-2.jpg" alt="自然资源交易">
          <span class="span">自然资源交易</span>
          <span class="border" />
        </a>
      </li>
      <li>
        <a :href="zzcgEntryLink" title="科技成果转化" target="_blank">
          <img src="@/assets/images/home/login-entry-5.jpg" alt="科技成果转化">
          <span class="span">科技成果转化</span>
          <span class="border" />
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import BlockHeadLine from "@/views/home/components/BlockHeadLine.vue";
import { NAV_MENU_CODE } from "@/utils/constant";
import { mapGetters } from "vuex";
export default {
  name: "LoginEntry",
  components: { BlockHeadLine },
  props: {
    // patientIn: {
    //   type: Object,
    //   default () {
    //     return {}
    //   }
    // }
  },
  data() {
    return {
      dialogVisible: false
    };
  },
  // 监听属性 类似于data概念
  computed: {
    ...mapGetters(["allMenusList"]),
    dljgEntryLink() {
      return this.$router.resolve({ path: "/porperty/list/xmgg_gyzcjy", query: { businessType: "" }})?.href
    },
    pwEntryLink() {
      return this.$router.resolve({ path: "/purchase/list/xmxx", query: { noticeType: "", projectType: "" }})?.href
    },
    cgfEntryLink() {
      return this.$router.resolve({ path: "/porperty/list/xmgg_zrzyjy", query: { businessType: "" }})?.href
    },
    gysEntryLink() {
      return this.allMenusList.find(item => item.code === NAV_MENU_CODE.NCCQJY)?.path || ""
    },
    zzcgEntryLink() {
      return this.allMenusList.find(item => item.code === NAV_MENU_CODE.KJCGZH)?.path || ""
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  },
  // 方法集合
  methods: {}
};
</script>

<style scoped lang="scss">
.login-entry{
  .login-entry-head{
    border-bottom: 2px solid #eee;
    h3{
      font-size: 16px;
      font-weight: bold;
      line-height: 2;
      position: relative;
      &::after{
        content: '';
        display: block;
        width: 100%;
        height: 2px;
        background-color: $--color-primary;
        position: absolute;
        bottom: -2px;
        left: 0;
      }
    }
    .register-btn{
      width: 70px;
      height: 20px;
      border-radius: 9px;
      border: 1px solid $--color-primary;
      color: $--color-primary;
      text-align: center;
      line-height: 18px;
      font-size: 12px;
      &:hover{
        text-decoration: none;
        background-color: $--color-primary;
        color: #fff;
      }
    }
  }
  ul{
    li{
      width: 140px;
      height: 90px;
      text-align: center;
      & + li{
        margin-left: 20px;
      }
      a{
        display: block;
        position: relative;
        width: 100%;
        height: 100%;
        img {
          width: 100%;
          height: 100%;
        }
        &:hover{
          img{
            opacity: 0.8;
          }
        }
        .span{
          color: #333;
          font-weight: bold;
          font-size: 14px;
          position: absolute;
          left: 9px;
          top: 20px;
        }
        .border{
          width: 30px;
          height: 4px;
          background: #E15717;
          position: absolute;
          left: 9px;
          top: 45px;
        }
      }
      &.quickly-item{
        width: 150px;
        height: 80px;
        border: 1px solid #ddd;
        &:hover{
          border-color: $--color-primary;
          opacity: 0.8;
        }
        a{
          display: flex;
          flex-flow: column;
          align-items: center;
          justify-content: center;
          img{
            height: 28px;
            width: 28px;
            object-fit: contain;
          }
          span{
            position: static;
            transform: none;
            font-size: 14px;
            font-weight: bold;
            line-height: 1;
            padding-top: 10px;
          }
        }
      }
    }
  }
}
.login-entry-pop{
  width: 100%;
  height: 340px;
  .login-entry-pop-item{
    width: 200px;
    height: 250px;
    display: block;
    position: relative;
    overflow: hidden;
    &:first-child{
      background: url("@/assets/images/home/login-entry-pb.jpg") no-repeat center / cover;
    }
    &:last-child{
      background: url("@/assets/images/home/login-entry-kb.jpg") no-repeat center / cover;
    }
    &:after{
      content: '';
      display: block;
      width: 100%;
      height: 100%;
      background-color: #000;
      opacity: 0;
      transition: opacity 0.4s;
      position: absolute;
      left: 0;
      top: 0;
    }
    h3{
      font-size: 18px;
      color: #fff;
      font-weight: bold;
      padding-left: 20px;
      position: absolute;
      left: 0;
      bottom: 40px;
      transition: transform 0.25s;
      &::after{
        content: '';
        display: block;
        width: 60px;
        height: 6px;
        border-radius: 3px;
        background-color: $--color-primary;
        position: absolute;
        left: 20px;
        bottom: 0;
        transform: translateY(15px);
      }
    }
    .hover-txt-box{
      width: 100%;
      height: 100%;
      //background-color: rgba(0,0,0,0.4);
      position: absolute;
      left: 0;
      top: 0;
      padding: 15px;
      transform: translateX(-100%);
      transition: transform 0.5s;
      z-index: 999;
      span{
        color: #fff;
        font-size: 14px;
        line-height: 1.5;
      }
    }
    &:hover{
      h3{
        transform: translateY(200px);
      }
      .hover-txt-box{
        transform: translateX(0);
      }
      &:after{
        opacity: 0.4;
      }
    }
  }
}

::v-deep {
  .login-entry-dialog{
    .el-dialog__body{
      padding-top: 0;
    }
  }
}
</style>
